import React, { useEffect } from 'react';
import { NavigationProp, useNavigation } from '@react-navigation/native';
import { LPRParamList } from '../../../typings/Params';
import Filters from '../../../components/Filter';
import { translate } from '../../../services/translate';
import FilterInput from '../../../components/Filter/components/FilterInput';
import { PlateType } from '../../../services/central-api/license-plate-recognition';
import PlateTypeDropdown from '../../../components/lpr/PlateTypeDropdown';
import { useForm } from 'react-hook-form';
import { MyCheckbox } from '../../../components/MyCheckbox';

interface Props {
    filters: LPRParamList['Plates'];
    setFilters: React.Dispatch<React.SetStateAction<LPRParamList['Plates']>>;
    plateFilter: string;
    setPlateFilter: React.Dispatch<React.SetStateAction<string>>;
}

interface FiltersForm {
    onlyActive: boolean;
    plateType: PlateType | 'all';
}

export default function LprPlateFilters({ filters, setFilters, setPlateFilter, plateFilter }: Props) {
    const navigation = useNavigation<NavigationProp<LPRParamList, 'Plates'>>();

    const defaultEmptyValues: FiltersForm = {
        onlyActive: true,
        plateType: 'all',
    };

    const form = useForm<FiltersForm>({
        defaultValues: defaultEmptyValues,
        mode: 'onChange'
    });

    useEffect(() => {
        form.reset({
            onlyActive: filters.onlyActive ?? true,
            plateType: filters.type ?? 'all'
        });

    }, []);

    const handleCleanFilter = () => {
        setPlateFilter('');
        form.reset(defaultEmptyValues);
    };

    const handleFilter = () => {
        const values = form.getValues();
        setFilters({
            ...filters,
            plate: plateFilter ? plateFilter : undefined,
            page: 0,
            onlyActive: values.onlyActive,
            type: values.plateType !== 'all' ? values.plateType : undefined,
        });

        navigation.setParams({
            ...filters,
            plate: plateFilter ? plateFilter : undefined,
            page: 1,
            onlyActive: values.onlyActive,
            type: values.plateType !== 'all' ? values.plateType : undefined,
        });
    };

    return (
        <Filters onCleanFilters={handleCleanFilter} onFilters={handleFilter}>
            <FilterInput
                label={translate('plate')}
                value={plateFilter}
                placeholder={translate('typeToSearch')}
                onChange={setPlateFilter}
            />
            <PlateTypeDropdown
                form={form}
                fieldName='plateType'
                zIndex={3}
                includeAll={true}
            />
            <MyCheckbox
                form={form}
                fieldName='onlyActive'
                label={translate('onlyActive')}
            />
        </Filters>
    );
}
